import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";


export class TicketTypeChangeAction extends BaseAction<void, {ticketType: string}> {

    override async run(): Promise<void | null> {
        try {
            const { ticketType } = this.params!;
            updateRecoilState("ticketTypeStateAtom", ticketType)
        } catch (error) {
            console.error("Error in TicketTypeChangeAction:", error);
        }
    }
}

// Create a singleton instance
export const ticketTypeChangeAction = new TicketTypeChangeAction(); 